export const auth = {
  'auth.welcome': 'Bienvenue sur subvention360',
  'auth.welcomeBack': 'Bon retour !',
  'auth.tagline': 'Candidatures de subventions alimentées par IA • Configuration en 2 minutes • 90% plus rapide',
  'auth.noCreditCard': '✓ Aucune carte de crédit requise',
  'auth.login': 'Connexion',
  'auth.signUp': 'Inscription',
  'auth.loginTitle': 'Connectez-vous à votre compte',
  'auth.loginDescription': 'Entrez vos identifiants pour accéder à votre tableau de bord',
  'auth.signupTitle': 'Créez votre compte',
  'auth.signupDescription': 'Commencez en moins de 2 minutes • Aucun détail initial requis',
  'auth.email': 'Email',
  'auth.password': 'Mot de passe',
  'auth.confirmPassword': 'Confirmer le mot de passe',
  'auth.enterEmail': 'Entrez votre email',
  'auth.enterPassword': 'Entrez votre mot de passe',
  'auth.confirmPasswordPlaceholder': 'Confirmez votre mot de passe',
  'auth.forgotPassword': 'Mot de passe oublié ?',
  'auth.loggingIn': 'Connexion...',
  'auth.signingUp': 'Inscription...',
  'auth.backToHome': 'Retour à l\'accueil',
  'auth.resetPasswordTitle': 'Réinitialiser le mot de passe',
  'auth.resetPasswordDescription': 'Entrez votre email pour recevoir un lien de réinitialisation',
  'auth.sendResetLink': 'Envoyer le lien',
  'auth.sendingResetLink': 'Envoi en cours...',
  'auth.cancel': 'Annuler',
  'auth.backToLogin': 'Retour à la connexion',
  'auth.resetEmailSent': 'Email de réinitialisation envoyé',
  'auth.resetEmailDescription': 'Vérifiez votre email pour un lien de réinitialisation de mot de passe.',
  'auth.resetFailed': 'Échec de la réinitialisation',
  'auth.resetFailedGeneric': 'Échec de l\'envoi de l\'email de réinitialisation. Veuillez réessayer.',
  'auth.resetFailedUserNotFound': 'Aucun compte trouvé avec cette adresse email.',
  'auth.resetFailedTooManyRequests': 'Trop de demandes. Veuillez patienter quelques minutes avant de réessayer.',
  'auth.success': 'Succès',
  'auth.loginSuccess': 'Connexion réussie',
  'auth.signupSuccess': 'Compte créé avec succès ! Veuillez vérifier votre email pour la vérification.',
  'auth.loginFailed': 'Échec de la connexion',
  'auth.signupFailed': 'Échec de l\'inscription',
  'auth.passwordsDoNotMatch': 'Les mots de passe ne correspondent pas',
  'auth.invalidCredentials': 'Hmm, ces identifiants ne correspondent pas. Veuillez vérifier votre email et mot de passe.',
  'auth.emailNotConfirmed': 'Presque fini ! Veuillez vérifier votre email et cliquer sur le lien de confirmation pour terminer l\'inscription.',
  'auth.tooManyRequests': 'Doucement ! Veuillez attendre quelques minutes avant de réessayer.',
  'auth.alreadyRegistered': 'Il semble que vous ayez déjà un compte ! Veuillez vous connecter à la place.',
  'auth.accountNotFound': 'Aucun compte trouvé avec cette adresse email.',
  'auth.invalidEmail': 'Cet email ne semble pas correct. Veuillez vérifier et réessayer.',
  'auth.userNotFound': 'Ce compte Google n\'est pas encore enregistré avec subvention360. Veuillez d\'abord vous inscrire avec email et mot de passe.',
  'auth.somethingWentWrong': 'Quelque chose s\'est mal passé. Veuillez réessayer.',
  'auth.accountCreated': 'Compte créé avec succès !',
  'auth.checkEmailVerification': 'Veuillez vérifier votre email pour vérifier votre compte.',
  'auth.orContinueWith': 'Ou continuez avec',
  'auth.continueWithGoogle': 'Continuer avec Google',
  'auth.noAccount': 'Vous n\'avez pas de compte ?',
  'auth.alreadyHaveAccount': 'Vous avez déjà un compte ?',
  'auth.signUpHere': 'Inscrivez-vous ici',
  'auth.signInHere': 'Connectez-vous ici',

  // Exigences du mot de passe
  'auth.passwordRequirements': 'Exigences du mot de passe :',
  'auth.passwordReq.minChars': 'Au moins 6 caractères',
  'auth.passwordReq.lowercase': 'Une lettre minuscule (a-z)',
  'auth.passwordReq.uppercase': 'Une lettre majuscule (A-Z)',
  'auth.passwordReq.number': 'Un chiffre (0-9)',
  'auth.passwordReq.special': 'Un caractère spécial (!@#$%*()_+-=[]{}|;\':"<>?,.~/~)',
  'auth.passwordPlaceholder': 'Mot de passe : minuscule, MAJUSCULE, 123, !@#',
  'auth.quickProfileSetup': '⚡ Après inscription, complétez votre profil en seulement 2 étapes rapides',

  // Session monitoring
  'auth.sessionExpiringSoon': 'Session bientôt expirée',
  'auth.sessionExpiryMessage': 'Votre session expirera dans {{minutesUntilExpiry}} minutes. Cliquez pour actualiser.',
  'auth.sessionExpiryMessage1Min': 'Votre session expirera dans 1 minute. Veuillez actualiser pour rester connecté.',
  'auth.refreshSession': 'Actualiser',
  'auth.sessionRefreshed': 'Session actualisée',
  'auth.sessionRefreshedMessage': 'Vous pouvez continuer à travailler.',
  'auth.sessionRefreshFailed': 'Échec de l\'actualisation de la session',
  'auth.sessionRefreshErrorMessage': 'Veuillez vous reconnecter.',
  'auth.rememberMe': 'Se souvenir de moi',
  'auth.staySignedIn': 'Rester connecté',
  'auth.sessionTimeout': 'Délai d\'expiration de la session',
  'auth.sessionTimeoutDescription': 'Votre session a expiré en raison d\'inactivité.',
} as const;